<template>
    <entity-list entity="plot" :use-events="false" :team-id="teamId"></entity-list>
</template>
<script>
import EntityList from '../../components/EntityList'
export default {
    components: {
        'entity-list': EntityList,
    },
    props: {
        teamId: {
            type: [String, Number],
            required: false,
        },
    },
}
</script>
